import { ReapitConnectSession } from '@reapit/connect-session'
import { BASE_HEADERS, URLS } from '../constants/api'
import { queryBuilder } from '../utils/common'

const fetchContacts = async (
  session: ReapitConnectSession,
  params: {
    pageSize?: number
    pageNumber?: number
    sortBy?: string
    name?: string
    active?: boolean
  },
) => {
  const requestParams = { ...params }
  if (!requestParams.sortBy) requestParams.sortBy = 'modified'
  if (requestParams.active == undefined) requestParams.active = true
  try {
    const response = await fetch(
      `${window.reapit.config.platformApiUrl}${URLS.CONTACTS}?${queryBuilder(requestParams)}`,
      {
        method: 'GET',
        headers: {
          ...BASE_HEADERS,
          Authorization: `Bearer ${session.accessToken}`,
        },
      },
    )

    if (response) {
      const responseJson = response.json()
      return responseJson
    }

    throw new Error('No response returned by API')
  } catch (err) {
    console.error('Error fetching Reapit documents', err)
    return {}
  }
}

const getContactById = async (session: ReapitConnectSession, id: string) => {
  try {
    const response = await fetch(`${window.reapit.config.platformApiUrl}${URLS.CONTACTS}/${id}?embed=documents`, {
      method: 'GET',
      headers: {
        ...BASE_HEADERS,
        Authorization: `Bearer ${session.accessToken}`,
      },
    })

    if (response) {
      const responseJson = response.json()
      return responseJson
    }

    throw new Error('No response returned by API')
  } catch (err) {
    console.error('Error fetching Reapit documents', err)
    return {}
  }
}

export const ContactsApiService = {
  getContactById,
  fetchContacts,
}
